import { render, staticRenderFns } from "./AdmLayout.vue?vue&type=template&id=52201618&scoped=true"
import script from "./AdmLayout.vue?vue&type=script&lang=js"
export * from "./AdmLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52201618",
  null
  
)

export default component.exports